import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import { connect } from 'react-redux';

import SignInModal from '../components/SignInModal';
import { toggleAgreementsTableOpen } from '../store/actions';
import { State } from '../store/reducer';
import { getIsAgreementsTableOpen } from '../store/selectors';
import AgreementsTable from './AgreementsTable';
import Map from './Map';
import Sidebar from './Sidebar';

const useStyles = makeStyles({
  divider: {
    height: 2
  },
  dividerVert: {
    width: 2
  },
  tableToggleButton: {
    display: 'flex'
  },
  '@global': {
    html: {
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    },
    body: {
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    },
    '#root': {
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    }
  }
});

export interface StateProps {
  isAgreementsTableOpen: boolean;
}

export interface DispatchProps {
  onAgreementsTableToggle: () => void;
}

type Props = StateProps & DispatchProps;

const App: React.FC<Props> = ({ isAgreementsTableOpen, onAgreementsTableToggle }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="row"
      height={1}
      width={1}
      alignItems="stretch"
      overflow="hidden"
    >
      <SignInModal />
      <Sidebar flex="0 0 340px" />
      <Divider orientation="vertical" className={classes.dividerVert} />
      <Box
        flex="1 1 0%"
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        overflow="hidden"
      >
        <Box flex="1 1 0%">
          <Map />
        </Box>
        <Divider className={classes.divider} />
        <Box flex="0 0 auto">
          <Button
            className={classes.tableToggleButton}
            size="small"
            fullWidth={true}
            onClick={onAgreementsTableToggle}
          >
            {isAgreementsTableOpen ? (
              <ExpandMoreIcon fontSize="small" />
            ) : (
              <ExpandLessIcon fontSize="small" />
            )}
          </Button>
        </Box>
        {isAgreementsTableOpen && <AgreementsTable flex="1 1 0%" />}
      </Box>
    </Box>
  );
};

const mapDispatch = {
  onAgreementsTableToggle: toggleAgreementsTableOpen
};

export const mapState = (state: State): StateProps => {
  return {
    isAgreementsTableOpen: getIsAgreementsTableOpen(state)
  };
};

export default connect<StateProps, DispatchProps, {}, State>(
  mapState,
  mapDispatch
)(App);
